export const Images = {
    auaLogo: require("./aualogo.png")
};